const resultsPath = "/listings";
const landingPagePath = "/landing-page";
export const landingPages = {
  attachments: {
    path: `${landingPagePath}/attachments`,
    title: "Attachments",
  },
  construction: {
    path: `${landingPagePath}/construction-equipment`,
    title: "Construction",
  },
  cranes: {
    path: `${landingPagePath}/cranes`,
    title: "Cranes",
  },
  power: {
    path: `${landingPagePath}/power-generators`,
    title: "Power Generators",
  },
  trailers: {
    path: `${landingPagePath}/trailers`,
    title: "Trailers",
  },
  trucks: {
    path: `${landingPagePath}/trucks`,
    title: "Trucks",
  },
  waterTrucks: {
    path: `${landingPagePath}/water-trucks-tanks`,
    title: "Water Trucks",
  },
};
const specials = {
  path: "/specials",
  title: "Specials",
};

export const routes = {
  alerts: {
    path: "/alerts",
    title: "Alerts",
  },
  blog: {
    path: "/blog",
    title: "Knowledge Center",
  },
  blogCategory: {
    path: "/blog/category",
    title: "Category",
  },
  blogTag: {
    path: "/blog/tag",
    title: "Tag",
  },
  buy: {
    path: "/buy",
    title: "Buy Now",
  },
  campaignPage: {
    path: "/:slug(.*[Ee]vent.*|.*[Hh]olt.*|.*[Ss]ale.*|.*[Tt]exas.*)",
    title: "Campaign Page",
  },
  compare: {
    path: "/compare",
    title: "Compare",
  },
  compile: {
    path: "/catalog",
    title: "Catalogs",
  },
  consignment: {
    path: "/consignment",
    title: "Equipment Consignment Request",
  },
  contact: {
    path: "/contact",
    title: "Contact Us",
  },
  disclosures: {
    path: "/disclosures",
    title: "Disclosures",
  },
  emailSignup: {
    path: "/email-signup",
    title: "Weekly Used Equipment Email Sign-up",
  },
  download: {
    path: "/download",
    title: "Download PDF",
  },
  forgot: {
    path: "/password/forgot",
    title: "Forgot Password",
  },
  home: {
    path: "/",
    title: "Home",
  },
  landingPage: {
    path: landingPagePath,
    title: "Landing Page",
    pages: { ...landingPages },
  },
  location: {
    path: "/location",
    title: "Location",
  },
  login: {
    path: "/login",
    title: "Sales Login",
  },
  notFound: {
    path: "/not-found",
    title: "Page Not Found",
  },
  partners: {
    path: "/why-holt-equipment",
    title: "Why our equipment",
  },
  prequalify: {
    path: "/prequalify",
    title: "Pre-qualify",
  },
  preview: {
    path: "/preview",
    title: "Preview",
  },
  privacy: {
    path: "/privacy",
    title: "Privacy Policy",
  },
  reset: {
    path: "/password/reset",
    title: "Reset Password",
  },
  results: {
    path: resultsPath,
    title: "Listings",
    categories: [
      { path: resultsPath, title: "All" },
      { ...specials },
      { ...landingPages.construction },
      { ...landingPages.attachments },
      { ...landingPages.cranes },
      { ...landingPages.waterTrucks },
      { ...landingPages.trucks },
      { ...landingPages.trailers },
    ],
  },
  serviceHistory: {
    path: "/service-history",
    title: "Parts & Service History",
  },
  shortLink: {
    path: "/sl",
    title: "Short Link",
  },
  specials: { ...specials },
  terms: {
    path: "/terms",
    title: "Terms & Conditions",
  },
  watch: {
    path: "/watched-listings",
    title: "Watched Listings",
  },
  why: {
    path: "/why-holt",
    title: "Values + legacy",
  },
};
